import notFound from './modules/not-found';
import common from './modules/common';
import company from './modules/company';
import crm from './modules/crm';
import baibu from './modules/baibu';
import zhaobuyi from './modules/zhaobuyi';
import zhixiao from './modules/zhixiao';
import waybill from './modules/waybill';
import customer from './modules/customer';
import landingPages from './modules/landing-pages';
import demand from './modules/demand';
import baibuTask from './modules/baibu-task';
import enquired from './modules/enquired';
import forms from './modules/foms';

export default [
  {
    path: '/',
    name: 'Welcome',
    component: () => import(/* webpackChunkName: 'Welcome' */ '@/views/welcome.vue'),

  },
  {
    path: '/home',
    name: 'Home',
    component: () => import(/* webpackChunkName: 'home' */ '@/views/home.vue'),
  },
  {
    path: '/about',
    name: 'About',
    component: () => import(/* webpackChunkName: 'about' */ '@/views/about.vue'),
    meta: {
      auth: false,
    },
  },
  ...common,
  ...company,
  ...baibu,
  ...zhaobuyi,
  ...crm,
  ...zhixiao,
  ...waybill,
  ...landingPages,
  ...customer,
  ...demand,
  ...baibuTask,
  ...enquired,
  ...forms,
  notFound,
];
